/* eslint no-console: 0 */

import Vue from 'vue'  
import Search from '../shared/TSMsimpleSearchForm.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector("#searchform");
  const data = el.dataset;
  const app = new Vue({
    el,
    render(h){
      return h(Search, {
        props: {
            custom: data.custom
        }
      });
    }
  });
});
